import { render, staticRenderFns } from "./titleDescription.vue?vue&type=template&id=0e5a1ce2&"
import script from "./titleDescription.vue?vue&type=script&lang=js&"
export * from "./titleDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports